import { createFileRoute } from '@tanstack/react-router';
import { RelatorioCadastroRelacaoProdutos } from '@/features/relatorio/page/cadastro/relacao-produtos/RelatorioCadastroRelacaoProdutos';

export const Route = createFileRoute('/a/relatorio/cadastro/relacao-produtos')({
    component: RelatorioCadastroRelacaoProdutos,
});
